const PREFIX = "finco.partner.";

export function setStorage<T>(key: string, value: T): void {
  localStorage.setItem(`${PREFIX}${key}`, JSON.stringify(value));
}

export function getStorage<T>(key: string): T | null {
  const raw = localStorage.getItem(`${PREFIX}${key}`);
  if (raw == null) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export function removeStorage(key: string): void {
  localStorage.removeItem(`${PREFIX}${key}`);
}

export function clearStorage(): void {
  const keys: string[] = [];
  for (let i = 0; i < localStorage.length; i += 1) {
    const key = localStorage.key(i);
    if (key?.startsWith(PREFIX)) keys.push(key);
  }
  keys.forEach((key) => localStorage.removeItem(key));
}
